import { storage } from './storage';

const CONSENT_KEY = 'analytics-consent';

export function getAnalyticsConsent() {
  return storage.get(CONSENT_KEY);
}

export function setAnalyticsConsent(value) {
  storage.set(CONSENT_KEY, value);
  if (value === 'accepted' && window.__loadGA) {
    window.__loadGA();
  }
}

export function trackEvent(name, params) {
  if (window.gtag) window.gtag('event', name, params);
}
